export default __webpack_public_path__ + "static/media/Mask_Group_3.7bc19625.png";